/**
 * Created by JackCui on 2021/12/29
 */

export const popupSchemaHandle = {
  handle ({info, viewContent}, {buttonMap}) {
    return {
      _type: 'popup',
      viewComponentName: 'popup-render',
      buttons: buttonMap['section_bottom'],
      size: 'mini',
      viewContent: [{
        targetType: 'form',
        props: {
          span: info.columns
        },
        viewContent
      }]
    }
  }
}
